import { Subject } from 'rxjs'

// Singleton will not be used at server-side, it is for client-side user interaction
const listingsFilterCallStream = new Subject()

// This method is the way to emit new values through the subject
export const triggerListingsFilterCall = (args) => {
  listingsFilterCallStream.next(args)
}

// to prevent direct calls to listingsFilterCallStream.next from outside, just expose observable
export const listingsFilterCallStream$ = listingsFilterCallStream.asObservable()
